const styles = '*{box-sizing:border-box}:host{box-sizing:border-box;display:inline-block}:host([state=error]){--skapa-form-validation-colour:rgb(var(--colour-semantic-negative,224,7,81))}:host([state=success]){--skapa-form-validation-colour:rgb(var(--colour-semantic-positive,10,138,0))}:host([state=warning]){--skapa-form-validation-colour:rgb(var(--colour-semantic-caution,242,106,47))}:host([disabled]){--skapa-form-validation-colour:rgb(var(--colour-interactive-disabled-1,204,204,204));color:rgb(var(--colour-interactive-disabled-1,204,204,204));pointer-events:none}:host([disabled]) slot{color:inherit}:host([disabled]) slot::slotted(*){color:inherit}:host([disabled]) slot::slotted(skapa-payment-logo){opacity:.2}:host([disabled]) slot:not([name])::slotted(input:-webkit-autofill){-webkit-text-fill-color:rgb(var(--colour-interactive-disabled-1,204,204,204))}:host([disabled]) slot[name=helper]{display:none}.wrapper{align-items:center;background:rgb(var(--colour-neutral-1,255,255,255));border-radius:4px;display:flex;flex-direction:row;padding:0 .5rem;position:relative;width:100%}:host([read-only]) .wrapper{background-color:rgb(var(--colour-neutral-2,245,245,245))}slot{display:inline-flex}slot:not([name]){flex-grow:1}slot:not([name])::slotted(input){-webkit-appearance:none;appearance:none;background:none;border:0;color:rgb(var(--colour-text-and-icon-1,17,17,17))!important;font-size:1rem;height:3rem;line-height:1.5;outline:none;overflow:hidden;width:100%}slot:not([name])::slotted(input:-webkit-autofill){-webkit-text-fill-color:rgb(var(--colour-text-and-icon-1,17,17,17));-webkit-box-shadow:0 0 0 3rem rgb(var(--colour-neutral-1,255,255,255)) inset}::slotted(input){flex-grow:1}slot[name=prefix]{margin-inline-end:.25rem}slot[name=suffix]{margin-inline-start:.25rem}slot[name=prefix],slot[name=suffix]{color:rgb(var(--colour-text-and-icon-3,118,118,118));flex-basis:0;font-size:1rem;line-height:1.5;opacity:0;overflow:hidden;text-overflow:ellipsis;transition:opacity .1s cubic-bezier(.4,0,.4,1),visibility .1s cubic-bezier(.4,0,.4,1);visibility:hidden;white-space:nowrap;z-index:100}slot[name=label]{display:block}:host([filled]) slot[name=prefix],:host([filled]) slot[name=suffix],:host([focused]) slot[name=prefix],:host([focused]) slot[name=suffix]{flex-basis:auto;opacity:1;transition-delay:33ms;visibility:visible}.wrapper:after{border:1px solid var(--skapa-form-validation-colour,rgb(var(--colour-interactive-subtle-border-default,146,146,146)));border-radius:4px;bottom:0;box-sizing:border-box;content:" ";display:block;left:0;pointer-events:none;position:absolute;top:0;transition:box-shadow .1s cubic-bezier(.4,0,.4,1),border .1s cubic-bezier(.4,0,.4,1);width:100%}:host([read-only]) .wrapper:after{border-color:rgb(var(--colour-neutral-2,245,245,245))}:host([focused]) .wrapper:after{border:2px solid var(--skapa-form-validation-colour,rgb(var(--colour-interactive-emphasised-border-selected,0,88,163)))}:host([focused][read-only]) .wrapper:after{border:2px solid rgb(var(--colour-neutral-5,146,146,146))}slot[name=action]{margin-inline-start:.25rem}slot[name=action]::slotted(skapa-payment-logo){--payment-logo-size-enum:2;margin-inline-end:.25rem;margin-inline-start:.25rem}slot[name=icon]{margin-inline-end:.25rem}slot[name=label]::slotted(label){display:block;font-size:.875rem;line-height:1.571;margin:0 0 .125rem}slot[name=helper]{display:flex;margin-top:.25rem}slot[name=helper]::slotted(*){flex-grow:1}slot[name=helper]::slotted(skapa-character-counter){justify-content:end;padding-inline-start:.5rem}@media (forced-colors:active){:host([disabled]){--skapa-form-validation-colour:GrayText;color:GrayText}}';
import { SkapaElement } from "@ingka/skapa-webc-element";
import { HelperText } from "@ingka/helper-text-webc/passive.js";
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <slot name="label"></slot>
    <div class="wrapper">
      <slot name="icon"></slot>
      <slot name="prefix"></slot>
      <slot></slot>
      <slot name="suffix"></slot>
      <slot name="action"></slot>
    </div>
    <slot name="helper"></slot>
  `;
  return { main: template };
}
class InputField extends SkapaElement {
  constructor() {
    super();
    this.helperText = null;
    this.handleFocus = (ev) => {
      this.toggleAttribute("focused", ev.type === "focusin");
    };
    this.updateState = (ev) => {
      const target = ev.target;
      if (target && "nodeType" in target) {
        this.toggleAttribute(
          "filled",
          Boolean(target.value) && target.value !== ""
        );
      }
    };
    this.onSlotChange = ({
      target
    }) => {
      const prefixService = this.getPrefixService();
      if (target.name === "helper") {
        this.helperText = this.querySelector(
          prefixService.prefixReplacer("skapa-helper-text")
        );
      } else if (target.name === "action") {
        const assignedButton = this.querySelector(
          prefixService.prefixReplacer("skapa-icon-button[slot=action]")
        );
        if (assignedButton) {
          assignedButton.setAttribute("size", "xsmall");
          assignedButton.setAttribute("variant", "tertiary");
        }
      }
      this.micro(
        this.updateHelper,
        "reflect properties and attributes on assigned elements"
      );
    };
    this.updateHelper = () => {
      if (this.helperText) {
        this.helperText.state = this.state;
      }
      if (this.autoID) {
        const assignedInput = this.querySelector("input");
        const assignedLabel = this.querySelector("label");
        const characterCounter = this.querySelector(
          this.getPrefixService().prefixReplacer("skapa-character-counter")
        );
        if (assignedInput) {
          assignedInput.id = this.autoID;
          if (!assignedInput.hasAttribute("type")) assignedInput.type = "text";
        }
        if (assignedLabel) assignedLabel.htmlFor = this.autoID;
        if (this.helperText) {
          if (!this.helperText.id) this.helperText.id = `${this.autoID}-helper`;
          if (assignedInput)
            assignedInput.setAttribute("aria-describedby", this.helperText.id);
        }
        if (characterCounter) characterCounter.setAttribute("for", this.autoID);
      }
      this.querySelectorAll("*").forEach(
        (e) => e.toggleAttribute("disabled", this.disabled)
      );
      this.querySelector("input")?.toggleAttribute("readonly", this.readOnly);
    };
    this.gatherProperties(["state", "disabled", "readOnly", "autoID"], this);
    const shadow = this.attachShadow({ mode: "open" });
    const templates = this.getTemplates(generateTemplate);
    shadow.append(templates.main.content.cloneNode(true));
    shadow.addEventListener("slotchange", this.onSlotChange, {
      passive: true
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("focusin", this.handleFocus);
    this.addEventListener("focusout", this.handleFocus);
    this.addEventListener("input", this.updateState);
    this.addEventListener("change", this.updateState);
    this.micro(
      this.updateHelper,
      "reflect properties and attributes on assigned elements"
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("focusin", this.handleFocus);
    this.removeEventListener("focusout", this.handleFocus);
    this.removeEventListener("change", this.updateState);
    this.removeEventListener("input", this.updateState);
  }
  get state() {
    return this.getAttribute("state") || "regular";
  }
  set state(value) {
    if (value === "regular") {
      this.removeAttribute("state");
      return;
    }
    this.setAttribute("state", value);
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(value) {
    this.toggleAttribute("disabled", !!value);
  }
  get readOnly() {
    return this.hasAttribute("read-only");
  }
  set readOnly(value) {
    this.toggleAttribute("read-only", !!value);
  }
  get autoID() {
    return this.getAttribute("auto-id");
  }
  set autoID(value) {
    if (value) this.setAttribute("auto-id", value);
    else this.removeAttribute("auto-id");
  }
  attributeChangedCallback(name) {
    this.micro(
      this.updateHelper,
      "reflect properties and attributes on assigned elements"
    );
  }
}
InputField.skapaTagName = "input-field";
InputField.skapaDependencies = [HelperText];
InputField.observedAttributes = [
  "state",
  "disabled",
  "read-only",
  "auto-id"
];
export {
  InputField
};
